import { STRINGS } from '@/constants/strings';
import { MAX_AVATAR_FILE_SIZE, MESSAGES } from '@/features/player/schema/mutate-player-schema';
import { countPhoneDigits } from '@/utils/helper';
import * as yup from 'yup';

type MutateCoachAvatar = {
  uri?: string | null | undefined;
  fileSize?: number | undefined;
};

export type MutateCoachForm = {
  phoneNumber?: string | null | undefined;
  countryCode?: string | null | undefined;
  streetAddress: string;
  streetAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  avatar?: MutateCoachAvatar | null | undefined;
};

export const mutateCoachSchema = (): yup.ObjectSchema<MutateCoachForm> =>
  yup.object({
    phoneNumber: yup
      .string()
      .test('digits-range', STRINGS.mutatePlayer.validation.phoneNumberDigitsRange, val => {
        if (!val) return true;
        const n = countPhoneDigits(val);
        return n >= 10 && n <= 24;
      })
      .optional()
      .nullable(),
    countryCode: yup.string().optional().nullable(),
    streetAddress: yup.string().trim().defined().max(200),
    streetAddress2: yup.string().trim().defined().max(200),
    city: yup.string().trim().defined().max(100),
    state: yup.string().trim().defined(),
    zipCode: yup.string().trim().defined().max(15),
    avatar: yup
      .object({
        uri: yup.string().required(MESSAGES.fieldRequired).optional().nullable(),
        fileSize: yup.number().min(1).max(MAX_AVATAR_FILE_SIZE, MESSAGES.avatarTooLarge).optional(),
      })
      .optional()
      .nullable(),
  });
